/**
 * 用户信息相关辅助函数
 * @since 19/09/04
 */

import store from 'store';
import { isEmpty } from '@fe/common/lib/check-types';

/**
 * 判断是否展示兔展品牌信息
 */
export function showRabbitBrandInfo(user) {
  const userState = user || store.getState().userInfo;
  const info = userState.platformConfigInfo && userState.platformConfigInfo;
  // 还未加载完用户信息（platformConfigInfo='unset'）,避免图标闪烁
  // 初始化的时候是个空对象，先不显示避免闪烁，之后不再是空对象再走正常的判断逻辑
  if (info === 'unset' || isEmpty(userState)) {
    return false;
  } else {
    return info && info.hideRabbitBrandInfo ? false : true;
  }
}

/**
 * 判断是否 是联合登陆
 */
export function isJointLogin(user) {
  const info = user.platformConfigInfo;
  if (info === 'unset' || isEmpty(info)) {
    return false;
  }
  return info === undefined ? true : !!info;
}

/**
 * 判断是否自动生成订单
 */
export function isAutoPay(user) {
  const userState = user || store.getState().userInfo;
  const isAutoPay = userState.isAutoPay && Boolean(userState.isAutoPay);
  return isAutoPay;
}

// 获取 隐藏模版市场付费模版
export function getPayTemplate(platformConfigInfo) {
  if (
    platformConfigInfo &&
    platformConfigInfo !== null &&
    platformConfigInfo !== 'unset' &&
    platformConfigInfo.hidePayInfo
  ) {
    const hidePayInfo = JSON.parse(platformConfigInfo.hidePayInfo);
    return hidePayInfo.hidePayTemplate;
  }
  return false;
}

/**
 * 是否企业用户
 *
 * @export
 * @return {boolean} result
 */
export function isOrgUser() {
  const userState = store.getState().userInfo || {};
  return !!userState.organizeId;
}

/**
 * 判断是否 展示平台专区Tab
 */
export function isShowOpenZone(user) {
  const userState = user || store.getState().userInfo;
  if (isEmpty(userState)) return false;
  // 联合登陆
  if (isJointLogin(userState)) {
    if (userState.platformConfigInfo === undefined) return false;
    const { openPlatformTemplateMarket } = userState.platformConfigInfo;
    return !!openPlatformTemplateMarket;
  }
  // 兔展登陆
  const { openPlatformZoneConfigVO } = userState;
  if (!openPlatformZoneConfigVO) return false;
  const { openPlatformTemplateMarket } = openPlatformZoneConfigVO;
  return !!openPlatformTemplateMarket;
}

/**
 * 判断是否展示模板二维码
 */
export function isShowStoreTemplateQRCode() {
  const userInfo = store.getState().userInfo;
  const styleRules = userInfo.styleRules;
  if (!styleRules) {
    return true;
  } else {
    return styleRules.storeQRCode !== false;
  }
}
